import { Card, ProgressBar } from "@blueprintjs/core";

type LoadingCardProps = {
  title: string;
};

export function LoadingCard({ title }: LoadingCardProps) {
  return (
    <div className="flex justify-center">
      <div className="mt-8">
        <Card>
          <ProgressBar animate intent="primary" stripes value={1} />
          <p>Loading {title}...</p>
        </Card>
      </div>
    </div>
  );
}
